<template>
  <div class="info-div">
    <van-cell center is-link :border="false" @click="openPersional">
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <div class="box-flex">
          <img class="header-img" :src="userInfo.fileKey" />
          <div class="item-right">
            <p class="custom-title top-tex">{{userInfo.name}}</p>
            <p class="text-bottom" v-if="userInfo.deptName">科室：{{userInfo.deptName}}</p>
          </div>
        </div>
      </template>
    </van-cell>

    <div class="box-flex2">
      <div class="item-box2 van-ellipsis">
        <p class="box2-p1">所在工会</p>
        <p class="box2-p2 van-ellipsis">{{userInfo.unionName}}</p>
      </div>
      <div class="item-box2">
        <p class="box2-p1">手机号</p>
        <p class="box2-p2">{{userInfo.phone}}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  data() {
    return {};
  },
  created() {
    console.log(this.userInfo);
  },
  methods: {
    openPersional() {
      //跳转个人信息
      this.$router.push("/personalInfo");
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';

.header-img {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 1px solid #fff;
}

.van-icon::before {
  color: #fff;
}

.item-right {
  // flex: 1;
  color: #fff;
  margin: auto 0 auto 16px;
  width: 54%;

  .top-tex {
    font-size: 17px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    margin-bottom: 2px;
    padding-left: 10px;
  }

  .text-bottom {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    display: inline-block;
    padding: 5px 10px;
    text-align: center;
    line-height: 18px;
    border-radius: 4px;
    text-align: justify;
    // width: 63%;
  }
}

.box-flex {
  display: flex;
}

.van-cell--center {
  background: none;
}

.box-flex2 {
  display: flex;
  justify-content: center;
  margin: 30px 10px 10px 10px;

  .item-box2 {
    flex: 1;
    text-align: center;
  }

  .box2-p1 {
    height: 21px;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 21px;
  }

  .box2-p2 {
    height: 17px;
    font-size: 12px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 17px;
  }
}
</style>